import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#333',
        secondary: '#DF731C',
        orange: '#FDB71A',
        blueDark: '#2F80C2'
      }
    }
  }
})
